export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=5fafc434&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/price-lists/favorites/index.vue?vue&type=template&id=5fafc434&
// module id = 1425
// module chunks = 0